import * as api from '../../../../api';
import { loadUsers as loadCompanyUsers } from '../../Services';

export const loadUserInfo = async (id, companyId) => {
    const [user, roles, groups, users] = await Promise.all([
        loadUser(id, companyId),
        loadRoles(companyId),
        loadGroups(companyId),
        loadUsers(companyId),
    ]);
    return {
        user,
        roles,
        groups,
        users,
    };
};

export const loadUserNew = async companyId => {
    const [users, roles, groups, companyUsers] = await Promise.all([
        loadUsers(companyId),
        loadRoles(companyId),
        loadGroups(companyId),
        loadCompanyUsers(companyId),
    ]);
    return {
        users,
        roles,
        groups,
        companyUsers: companyUsers.users,
    };
};

export const loadUser = async (id, companyId) => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/users/${id}`
    );
    return data;
};

export const loadUsers = async companyId => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/users?all_users`
    );
    return data;
};

export const removeUsers = (users, companyId) => {
    const uuids = users.map(user => ({ uuid: user.uuid }));
    return api.remove(`/api/organization/${companyId}/partner/users`, {
        uuids,
    });
};

export const removeUsersAccess = (users, companyId) => {
    const uuids = users.map(user => ({ uuid: user.uuid }));
    return api.remove(`/api/organization/${companyId}/partner/users`, {
        uuids,
        type: 'access',
    });
};

export const enableUsersAccess = (users, companyId) => {
    const uuids = users.map(user => ({ uuid: user.uuid }));
    return api.patch(`/api/organization/${companyId}/partner/users`, {
        uuids,
        type: 'access',
    });
};

export const updateUser = (user, companyId) => {
    return api.patch(`/api/organization/${companyId}/partner/users`, user);
};

export const saveUser = (user, companyId) => {
    return api.post(`/api/organization/${companyId}/partner/users`, user);
};

export const loadCompany = async companyId => {
    const { data } = await api.get(`/api/organizations/${companyId}`);
    return data[0];
};

const loadRoles = async companyId => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/roles`
    );
    return data;
};

const loadGroups = async companyId => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/company_groups`
    );
    return data;
};
